module.exports = __webpack_public_path__ + "img/receipt.189525af.svg";